import { render } from "./editPageSectionsModal.vue?vue&type=template&id=b095b86c"
import script from "./editPageSectionsModal.vue?vue&type=script&lang=js"
export * from "./editPageSectionsModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__